import React from 'react';
import * as Types from './types';
import * as Panel2 from './panel';
import {PanelComp2} from './PanelComp';
import * as Op from './cg/ops';

type PanelWBObjectProps = Panel2.PanelConverterProps;

const PanelWBObject: React.FC<PanelWBObjectProps> = props => {
  const mediaNode = Op.opFileMediaFile({file: props.input.path});
  return (
    <PanelComp2
      inputType={Spec.convert(props.inputType)}
      input={{path: mediaNode}}
      loading={props.loading}
      panelSpec={props.child}
      configMode={false}
      config={props.config}
      context={props.context}
      updateConfig={props.updateConfig}
      updateContext={props.updateContext}
    />
  );
};

export const Spec: Panel2.PanelConvertSpec = {
  id: 'wb-object-file',
  Component: PanelWBObject,
  convert: (inputType: Types.Type) => {
    if (Types.isSimpleType(inputType)) {
      return null;
    }
    if (inputType.type !== 'file' || inputType.wbObjectType == null) {
      return null;
    }
    return inputType.wbObjectType;
  },
};
